import React, { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'

import { YandexMarketScreenTabs } from './YandexMarketScreenTabs'
import { OrdersTableTab, StoreOrdersScreen } from './StoreOrdersScreen'
import { YandexMarketLoadOrdersForm } from './YandexMarketLoadOrdersForm'

import { useLogic, useStore } from '../hooks/storeHook'

import { YmAccountProps } from '../types/accountProps'
import { createYmOrderColumns } from '../types/yandexMarketOrderColumns'
import { YandexMarketDeliveryType } from '../server/mpsklad_core/Entity/YandexMarket/Enums/YandexMarketDeliveryType'

export const YandexMarketOrdersTabsScreen =
  () => <YandexMarketScreenTabs ScreenComponent={YandexMarketOrdersScreen}/>

export const YandexMarketOrdersScreen =
  observer(
    ({account}: YmAccountProps) => {
      const {api, yandexMarketOrderLoaders} = useLogic()
      const {orderStore: {createYandexMarketOrdersTable}} = useStore()

      const ymOrderColumns = useMemo(
        () => createYmOrderColumns(account),
        [account])

      const yandexMarketOrders = useMemo(
        () => createYandexMarketOrdersTable(account.id),
        [createYandexMarketOrdersTable, account])

      useEffect(() => yandexMarketOrderLoaders.addHandler(yandexMarketOrders.load),
        [yandexMarketOrderLoaders, yandexMarketOrders])

      const tabs = useMemo(() => {
          const commonTabs = [OrdersTableTab.Active, OrdersTableTab.WithErrors] as const

          return account.deliveryType === YandexMarketDeliveryType.FBY
                 || account.deliveryType === YandexMarketDeliveryType.UzbFBY
                 ? [...commonTabs, OrdersTableTab.LoadOrders] as const
                 : commonTabs
        },
        [account.deliveryType])

      return (
        <StoreOrdersScreen
          account={account}
          tabValues={tabs}
          orders={yandexMarketOrders}
          columns={ymOrderColumns}
          searchPlaceholder="Id / Id в Yandex.Market / Ваш SKU товара"
          pullOrdersWithErrors={api.order.pullYmOrdersWithErrors}
          exportOrdersToExcel={api.order.exportYandexMarketToExcel}
          LoadOrdersFormComponent={YandexMarketLoadOrdersForm}
        />
      )
    })